export const CUSTOM_MAIL_BATCH_BUDGET = 400_000;

export function batchCustomMailRequests<T>(mails: T[]): T[][] {
  const batches: T[][] = [];
  let batch: T[] = [];
  let size = 4; // Array brackets and outer quotes, including JSON string escaping for the websocket payload.
  for (const mail of mails) {
    const mailSize = JSON.stringify(JSON.stringify(mail)).length - 2;
    if (mailSize + 4 >= CUSTOM_MAIL_BATCH_BUDGET)
      throw new Error(
        'Einzelne E-Mail ist zu groß für den Versand. Bitte den Inhalt oder die Empfängerliste verkürzen.',
      );
    if (size + mailSize + (batch.length ? 1 : 0) >= CUSTOM_MAIL_BATCH_BUDGET) {
      batches.push(batch);
      batch = [];
      size = 4;
    }
    size += mailSize + (batch.length ? 1 : 0);
    batch.push(mail);
  }
  if (batch.length) batches.push(batch);
  return batches;
}

export async function sendPendingMailBatches<T>(batches: T[][], sendBatch: (batch: T[]) => Promise<unknown>) {
  while (batches.length) {
    await sendBatch(batches[0]!);
    // Keep failed batches for retry; completed batches must never be sent again in this dialog.
    batches.shift();
  }
}
